// istanbul ignore file
import styled from "styled-components";

type DividerProps = {};
const Divider = styled.div.attrs((props: DividerProps) => props)`
  border-top: 1px solid ${(props) => props.theme.color.border.default};
`;
export { Divider };
